import { render, staticRenderFns } from "./HeaderHelp.vue?vue&type=template&id=0fa5be4c&scoped=true&"
import script from "./HeaderHelp.vue?vue&type=script&lang=js&"
export * from "./HeaderHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5be4c",
  null
  
)

export default component.exports